import React, { useState } from 'react'
import {
  PictureAsPdf as PdfIcon,
  Description as DocumentIcon,
  TableChart as SpreadsheetIcon,
  Slideshow as PresentationIcon,
  Image as ImageIcon,
  Movie as VideoIcon,
  Audiotrack as AudioIcon,
  InsertDriveFile as FileIcon,
} from '@material-ui/icons'
import { fileKind } from 'shared/utils/fileType'

const GREY = '#757575'
const GREY_TINT = '#f5f5f5'

// One icon, color and pale background per kind of file (see shared/utils/fileType.js for which extensions are which)
const ICONS = {
  pdf: { Icon: PdfIcon, color: '#d32f2f', tint: '#fdecea' },
  document: { Icon: DocumentIcon, color: '#1976d2', tint: '#e3f2fd' },
  spreadsheet: { Icon: SpreadsheetIcon, color: '#2e7d32', tint: '#e8f5e9' },
  presentation: { Icon: PresentationIcon, color: '#e65100', tint: '#fff3e0' },
  image: { Icon: ImageIcon, color: GREY, tint: GREY_TINT },
  video: { Icon: VideoIcon, color: GREY, tint: GREY_TINT },
  audio: { Icon: AudioIcon, color: GREY, tint: GREY_TINT },
  other: { Icon: FileIcon, color: GREY, tint: GREY_TINT },
}

// The icon of a file by its name / URL, bare (no circle around it) and in the color of its kind
export function FileTypeIcon({ name, url, style }) {
  const { Icon, color } = ICONS[fileKind(name, url)]
  return <Icon style={{ color, flexShrink: 0, ...style }} />
}

/**
 * The file's icon (a little under two thirds of the tile, so 6px of color around it) on a 32px rounded tile tinted in the color of its kind, so the type reads at a glance in a list. With `thumbnailUrl`
 * (an image the browser can draw) the tile shows the picture itself, falling back to the icon if it fails to load.
 */
export function FileTypeTile({ name, url, thumbnailUrl, size = 32 }) {
  const [broken, setBroken] = useState(false)
  const { tint } = ICONS[fileKind(name, url)]

  return (
    <div
      style={{
        width: size, height: size, borderRadius: 8, backgroundColor: tint, flexShrink: 0, overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      {thumbnailUrl && !broken
        ? <img src={thumbnailUrl} alt="" loading="lazy" onError={() => setBroken(true)} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        : <FileTypeIcon name={name} url={url} style={{ fontSize: Math.round(size * 0.625) }} />}
    </div>
  )
}

export default FileTypeIcon
